module.exports = __webpack_public_path__ + "img/tishengji3.aa0176cc.jpg";